import { useLocation } from 'react-router-dom';

export const VendorRoutes = () => {
  const { pathname, search } = useLocation();

  window.location.replace(`${process.env.REACT_APP_VENDOR_APP_URL}${pathname}${search}`);

  return null;
};
